<template>
  <header class="site-header">
    <nav class="nav" aria-label="主导航">
      <router-link class="brand-lockup" to="/" aria-label="返回首页">
        <img class="logo-mark" src="/assets/app-logo.png" alt="冷丰 Logo" />
        <span class="brand-name">
          <strong>冷丰生态</strong>
          <span>社区零售应用矩阵</span>
        </span>
      </router-link>

      <div class="nav-links">
        <router-link to="/">首页</router-link>
        <router-link
          v-for="product in products"
          :key="product.key"
          :to="`/products/${product.key}`"
        >
          {{ product.name }}
        </router-link>
        <router-link to="/download">下载中心</router-link>
        <router-link :to="{ path: '/', hash: '#about' }">关于我们</router-link>
      </div>
    </nav>
  </header>
</template>

<script>
import { products } from '@/data/products'

export default {
  name: 'SiteHeader',
  data() {
    return {
      products
    }
  }
}
</script>

<style scoped lang="scss">
.site-header {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid rgba(220, 227, 238, 0.86);
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(16px);
}

.nav {
  width: min(1120px, calc(100% - 40px));
  min-height: 68px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-width: 0;
}

.brand-lockup {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  flex: 0 1 auto;
  color: var(--ink);
  text-decoration: none;
}

.logo-mark {
  width: 44px;
  height: 44px;
  display: block;
  flex: 0 0 auto;
  border-radius: 22.5%;
  object-fit: cover;
  box-shadow: 0 10px 22px rgba(255, 75, 11, 0.24);
}

.brand-name {
  min-width: 0;

  strong {
    display: block;
    overflow: hidden;
    font-size: 17px;
    line-height: 1.2;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    display: block;
    margin-top: 2px;
    color: var(--muted);
    font-size: 12px;
  }
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 22px;
  min-width: 0;
  color: #42506a;
  font-size: 14px;

  a {
    padding: 8px 0;
    color: inherit;
    text-decoration: none;
    white-space: nowrap;
  }

  a:hover,
  .router-link-active {
    color: var(--brand);
  }
}

@media (max-width: 760px) {
  .nav {
    width: min(100% - 32px, 1120px);
    min-height: 0;
    align-items: flex-start;
    flex-direction: column;
    padding: 12px 0 10px;
    gap: 10px;
  }

  .logo-mark {
    width: 40px;
    height: 40px;
  }

  .nav-links {
    width: 100%;
    overflow-x: auto;
    gap: 16px;
    margin: 0 -16px;
    padding: 0 16px 4px;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }

  .nav-links::-webkit-scrollbar {
    display: none;
  }
}

@media (max-width: 420px) {
  .brand-name span {
    display: none;
  }

  .logo-mark {
    width: 38px;
    height: 38px;
  }

  .nav-links {
    font-size: 13px;
  }
}
</style>
